import React, {Component} from 'react';
import { connect }        from 'react-redux';

//components
import TopBanner   from './sections/top_banner/top_banner';
import Search      from './sections/search/search';
import InfoGraphic from './sections/info_graphic/info_graphic';
import Instruction from './sections/instruction/instruction';
import Expansions from './sections/expansions/expansions';
import Statistics from './sections/statistics/statisrics';
import Recommendations from './sections/recommendations/recommendations';
import About from './sections/about/about';
import Manufacturers from './sections/manufacturers/manufacturers';
//assets
import './home.scss';


class Home extends Component {

    render() {
        return (
            <div className="home">
                <TopBanner/>
                <Search history={this.props.history}/>
                <InfoGraphic/>
                <Expansions/>
                <Instruction/>
                <Recommendations/>
                <Statistics/>
                <Manufacturers/>
                <About/>
            </div>
        );
    }
}

//add GD categories and deviceState to props
const mapStateToProps = store => {
    return {
        deviceState: store.state.deviceState,
        webMode: store.config.WebMode
    }
}
//map a doLgin function to props
const mapDispatchToProps = dispatch => {
    return {
    }
}

//connect to redux store - maps dispatch and redux state to props
export default connect(mapStateToProps, mapDispatchToProps, null, { pure: false })(Home);
